import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  userPreferenceUnitState,
  userPreferencesState,
} from '../../../../atoms/userPreferencesAtom/userPreferencesAtom';

import { ConsumptionUnitEnum } from '../../../../enum/ConsumptionUnitEnum';
import ForecastCircularWidget from './ForecastInfoWidget';
import MeterForecastHistoryWidget from './MeterForecastHistoryWidget';
import MeterForecastWizard from './MeterForecastWizard';
import { PeriodEnum } from '../../../../enum/PeriodEnum';
import { SDPTariffChoiceEnum } from '../../../../enum/SDPTariffChoiceEnum';
import { SdpResponse } from '../../../../models/SdpResponse';
import Skeleton from 'react-loading-skeleton';
import UnitSelector from '../UnitSelector';
import { roleAccessState } from '../../../../atoms/roleAccessAtom';
import { uiState } from '../../../../atoms/uiAtom';
import { useEffect } from 'react';
import { useGetAccount } from '../../../../hooks/accounts';
import { useLocation } from 'react-router-dom';

export interface MeterForecastProps {
  sdp?: SdpResponse | null;
}
export default function MeterForecast({ sdp }: MeterForecastProps) {
  const {
    isFetching: isFetchingGetAccount,
    isError: IsErrorGetAccount,
    refetch: refetchGetAccount,
    data: account,
  } = useGetAccount();
  const setUiState = useSetRecoilState(uiState);
  const { state } = useLocation();
  const unit = useRecoilValue(userPreferenceUnitState);
  const roleAccess = useRecoilValue(roleAccessState);
  const [userPreferencesAtom, setUserPreferences] = useRecoilState(userPreferencesState);
  useEffect(() => {
    if (state?.fromWizard) {
      refetchGetAccount();
    }
  }, [refetchGetAccount, state]);
  useEffect(() => {
    setUiState((state) => ({
      ...state,
      hasError: IsErrorGetAccount,
    }));
  }, [IsErrorGetAccount, setUiState]);

  const wizardSkeletonRenderer = (
    <div className="text-center">
      <Skeleton count={1} height={16} width="40%" className="mb-2" />
      <Skeleton count={1} height={16} width="80%" className="mb-4" />
      <Skeleton count={1} height={80} width="80%" className="mb-2" />
      <Skeleton count={1} height={16} width="70%" className="mb-4" />
      <Skeleton count={1} height={16} width="50%" className="mb-6" />
    </div>
  );

  const onChangeUnit = (value: ConsumptionUnitEnum) => {
    setUserPreferences((prev) => ({
      ...prev,
      unit: value,
    }));
  };

  return (
    <section className="meter-forecast">
      {isFetchingGetAccount || IsErrorGetAccount ? (
        wizardSkeletonRenderer
      ) : account?.data.onboardingDone === false ? (
        <div className="widget meter-forecast__wizard">
          <MeterForecastWizard sdp={sdp} />
        </div>
      ) : (
        <div className="row">
          {sdp?.tariffChoice === SDPTariffChoiceEnum.SOCIAL &&
            roleAccess?.myConsumption.hasToggleEuro &&
            roleAccess?.forecast.hasToggleEuro && (
              <div className="meter-forecast__unit-selector col-12 mb-4">
                <UnitSelector value={unit} onChange={onChangeUnit} />
              </div>
            )}

          <div className="col-12  col-lg-5 meter-forecast__circular-widget">
            <ForecastCircularWidget
              sdp={sdp}
              unit={unit}
              period={
                userPreferencesAtom.periodGranularity !== PeriodEnum.MONTHLY &&
                userPreferencesAtom.periodGranularity !== PeriodEnum.YEARLY
                  ? PeriodEnum.MONTHLY
                  : userPreferencesAtom.periodGranularity
              }
            />
          </div>
          <div className="col-12  col-lg-7   meter-forecast__line-widget">
            <div className="widget">
              <MeterForecastHistoryWidget sdp={sdp} />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
